'use client';

import { FinancialTable } from './FinancialTable';
import { WatchlistNewsSection } from './WatchlistNewsSection';
import { RESEARCH_PANEL_BODY_HEIGHT, PORTFOLIO_CARD_CLASSNAME } from './portfolioLayoutConstants';

export const PortfolioResearch = () => (
  <section className="grid items-stretch gap-3 lg:grid-cols-[minmax(0,2fr)_minmax(300px,1fr)]">
    <div className={`${PORTFOLIO_CARD_CLASSNAME} min-h-0`}>
      <FinancialTable variant="research" tableHeight={RESEARCH_PANEL_BODY_HEIGHT} />
    </div>

    <div className={`${PORTFOLIO_CARD_CLASSNAME} min-h-0`}>
      <WatchlistNewsSection bodyHeight={RESEARCH_PANEL_BODY_HEIGHT} />
    </div>
  </section>
);
